import { useCallback, useMemo } from 'react'
import { InferGetStaticPropsType } from 'next'

import { ssgPaths, ssgProps } from '@utils/server'
import { VenueMeta } from '@modules/venue/views/venue-meta'
import { serveEventCalendarProps } from '@modules/event/data/server'
import { EventCalendar } from '@modules/event/controllers/event-calendar'
import { VenuePageProvider } from '@modules/venue/controllers/venue-page-provider'
import { VenuePageNavigation } from '@modules/venue/views/venue-page-navigation'
import { useRouter } from 'next/router'
import { VenueEvent } from 'types/model'

export default function VenueEventsPage({
  venue,
  events,
  integrations,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  const router = useRouter()
  const currentYear = useMemo(() => new Date().getUTCFullYear(), [])
  const currentMonth = useMemo(() => new Date().getUTCMonth(), [])

  const breadcrumbs = useMemo(
    () => [
      {
        label: 'Venue',
        href: `/v/${venue.slug}`,
      },
      {
        label: 'All Events',
        href: `/v/${venue.slug}/events`,
      },
    ],
    [venue.slug]
  )

  const handleClick = useCallback(
    (event: VenueEvent) => {
      if (!event?.id) return
      router.push(`/e/${event.id}`)
    },
    [router]
  )

  return (
    <>
      <VenueMeta venue={venue} />
      <VenuePageProvider venue={venue} integrations={integrations}>
        <div className='max-w-6xl mx-auto'>
          <VenuePageNavigation breadcrumbs={breadcrumbs} />
        </div>
        <div className='w-full max-w-6xl px-3 py-3 mx-auto sm:px-8'>
          <EventCalendar
            title='Events'
            initialEvents={events}
            initialMonth={currentMonth}
            initialYear={currentYear}
            venue={venue}
            onCellClick={handleClick}
            showMobileBottomPaginator={false}
          />
        </div>
      </VenuePageProvider>
    </>
  )
}

export const getStaticProps = ssgProps(serveEventCalendarProps)

export const getStaticPaths = ssgPaths()
